module.exports = __webpack_public_path__ + "static/media/Малыгина А.С.  (ММ).e9b06504.pdf";